module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-message",
    class: _vm.type,
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('span', {
    staticClass: "message-icon",
    class: ("icon-" + _vm.type)
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d3f1e6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = 114
// module chunks = 49